import gql from 'graphql-tag';

export const DEAL_LISTING_ACTIVITY_FRAGMENT = gql`
  fragment DealListingEventActivityFields on DealEventActivityViewModel {
    id
    notes
    subject
    eventType
    activityStatus
    account {
      id
      name
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }
  }
`;
